import { useLocation } from 'react-router-dom';

const TopBar = ({ children }) => {
	const location = useLocation();

	const isGameScreen = location.pathname.startsWith('/game/') || location.pathname.startsWith('/results/');

	if (isGameScreen) {
		return null;
	}

	return <div className='w-full py-4 px-6 flex justify-end items-center absolute top-0 right-0 z-10'>{children}</div>;
};

export default TopBar;
